import {useEffect, useState} from "@wordpress/element";
const GooglePaySurcharge = () => {
    const [text, setText] = useState('');
    const [marginTop, setMarginTop] = useState('0px');

    useEffect(() => {
        if(typeof pgabfwSurcharge !== "undefined" && pgabfwSurcharge.success === '1'){
            let notice = pgabfwSurcharge.google_pay ?? '';
            setText(notice);
            (notice.length > 0)? setMarginTop('15px') : setMarginTop('0px');
        }
    }, []);

    return (
        <div style={{marginTop: marginTop}}><b>{ text }</b></div>
    );
}

window.addEventListener(
    'pgabfw-renderFooterComponentsGooglePay',
    e => e.detail.setComponent(<GooglePaySurcharge/>)
);